'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  from: null,
  previewText: null,
  seen: null,
  senderType: null,
  subject: null,
  timestamp: null
}, 'LatestEmailMessage');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/LatestEmailMessage.js
// module id = 447
// module chunks = 2 3